import React from 'react';
import { useParams } from 'react-router-dom';

import PositionUpdateForm from 'components/PositionAndAssignment/PositionUpdateForm/PositionUpdateForm';

const PositionUpdatePage: React.FC = () => {
  const { accountId = '', projectId = '' } = useParams();

  return <PositionUpdateForm accountId={accountId} projectId={projectId} data-testid="position-update-form" />;
};

export default PositionUpdatePage;
